
import Vue from 'vue'
import Vuex from 'vuex'
import settings from "./store/modules/settings";
import app from "./store/modules/app";

Vue.use(Vuex);
// 用Vuex.Store对象用来记录token
const store = new Vuex.Store({
  modules:{
    app,
    settings,
  },
  state: {
    // 存储token
    token:"",
    userName:"", // 可选
    isLogin:false
  },
  // getters,
  getters: {
    sidebar: state => state.app.sidebar,
    getToken(state){
      return state.token || localStorage.getItem("token") || "";
    },
    isLogin(state){
      return state.isLogin;
    },
  },

  mutations: {
    // 修改token，并将token存入localStorage
    setToken(state,token) {
      state.token = token;
      // localStorage.setItem('token', token);
      // console.log('store、localstorage保存token成功！');
    },
    delToken(state) {
      state.token = "";
      localStorage.removeItem("token");
    },
    // 可选
    setUserInfo(state, userName) {
      state.userName = userName;
      localStorage.setItem('userName', userName);
    },
    userStatus(state,flag){
      state.isLogin=flag;
    },
  },

  actions: {
    // removeToken: (context) => {
    // context.commit('setToken')
    // }
    setUser({commit},flag){
      commit("userStatus",flag);

    }

  },
});

export default store;
